import { useMemo } from "react";

import useTableSort from "components/Table/useTableSort";
import { WebhookDelivery } from "types/generated";

import {
  INITIAL_SORT_DIRECTION,
  INITIAL_SORT_OPTION,
  SORT_CONFIG,
  WEBHOOK_DELIVERIES_TABLE_FILTERS_STORAGE_KEY,
} from "./constants";
import { sortWebhookDeliveries } from "./helpers";

export const useSortingWebhookDeliveries = (deliveries: WebhookDelivery[] = []) => {
  const { sortDescriptor } = useTableSort({
    filtersOrderSettingsKey: WEBHOOK_DELIVERIES_TABLE_FILTERS_STORAGE_KEY,
    sortConfig: SORT_CONFIG,
    initialSortOption: INITIAL_SORT_OPTION,
    initialSortDirection: INITIAL_SORT_DIRECTION,
  });

  return useMemo(() => {
    if (sortDescriptor.column) {
      return sortWebhookDeliveries(deliveries, sortDescriptor);
    }

    return deliveries;
  }, [deliveries, sortDescriptor]);
};
